import { render, staticRenderFns } from "./AccountMoneyClaims.vue?vue&type=template&id=d709ae1e&"
import script from "./AccountMoneyClaims.vue?vue&type=script&lang=js&"
export * from "./AccountMoneyClaims.vue?vue&type=script&lang=js&"
import style0 from "./AccountMoneyClaims.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports